import {Component, ElementRef, NgZone, ViewChild} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {SettingsDattaService} from "@app/features/settings/settings.service";
import {DataService} from "@shared/services/data.service";
import {ToastService} from "@shared/services/toast.service";
import {FileHandle} from "@shared/directives/dragDrop.directive";
import {MapsAPILoader} from "@agm/core";

interface AvailabilitySchedule {
  deliveryMethod: 'DELIVERY' | 'IN_STORE';
  day: string;
  startTime: string;
  endTime: string;
  isActive: boolean;
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
  public selectedTab = 1;
  latitude: number = 31.9037641;
  longitude: number = 35.2034184;
  zoom: number = 13;
  geoCoder: google.maps.Geocoder | undefined;
  address = 'Ramallah';
  loadAddress = false;
  public countriesList: any[] = [];
  public submitted = false;
  public storeDetails = {
    name: '',
    category: {
      id: ''
    },
    currency: '',
    description: '',
    imageURL: ''
  }
  public data: any = {
    store:
      {
        name: "SomeWhere",
        logoUrl: "",
        description: "Dounts store",
        location: {
          name: "Ramallah Street",
          latitude: 31.0,
          longitude: 35.0,
          country: {
            name: "Palestine",
            countryCode: "ps",
            defaultCurrency: {
              name: "New shekel",
              symbol: "₪",
              code: "ILS",
              id: 1,
              createdDate: "2022-08-21T19:09:54.000+0000",
              updatedDate: "2022-08-21T19:09:54.000+0000"
            },
            id: 1,
            createdDate: "2022-08-21T19:09:54.000+0000",
            updatedDate: "2022-08-21T19:09:54.000+0000"
          },
          id: 2,
          createdDate: "2022-12-26T13:27:46.000+0000",
          updatedDate: "2022-12-26T13:27:46.000+0000"
        },
        storeCategory: {
          name: "Sweets",
          description: "Sweets and more",
          id: 1,
          createdDate: "2022-12-26T13:29:17.000+0000",
          updatedDate: "2022-12-26T13:29:17.000+0000"
        },
        isEcommerce: false,
        ecommerceStoreConfig: {
          allowCod: false,
          allowDelivery: false,
          allowInStoreOrder: false,
          deliveryRate: 0.0,
          id: 1,
          createdDate: "2025-02-14T17:34:36.000+0000",
          updatedDate: "2025-02-14T17:34:36.000+0000"
        },
        status: "ACTIVE",
        id: 3,
        createdDate: "2022-12-26T13:29:52.000+0000",
        updatedDate: "2023-01-31T10:14:02.000+0000"
      },
    accountDetail: {
      id: 9,
      firstName: "Muathe",
      lastName: "Jamil",
      emailAddress: "muathe@trigger-apps.com",
      storeName: "SomeWhere",
      locationCountry: "Palestine",
      balance: {
        currency: {
          name: "New shekel",
          symbol: "₪",
          code: "ILS",
          id: 1,
          createdDate: "2022-08-21T19:09:54.000+0000",
          updatedDate: "2022-08-21T19:09:54.000+0000"
        },
        balance: 0.5,
        id: 13,
        createdDate: "2022-12-26T13:29:51.000+0000",
        updatedDate: "2022-12-26T13:29:51.000+0000"
      },
      contactNumber: "0598171624"
    },
    storeTransferDetails: {
      countryCode: "ps",
      bankName: "Arab bank",
      IBAN: "1234123412341234"
    },
    language: "en"
  };
  public transferDetails = {
    countryCode: "",
    bankName: "",
    IBAN: ""
  }
  public accountDetails = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    contactNumber: ""
  }

  public ecommerceStoreConfig: any;
  public categoryList: any = [];
  public logoFileToUpload: any;
  logoFileReader: FileReader = new FileReader();
  public logoPreview: string | ArrayBuffer | null | undefined;
  countryId: any;
  @ViewChild('search', {static: false}) public searchElement: ElementRef | undefined;
  public days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  public dayError: { [key: number]: string } = {};
  public minimizedSections: { [key: string]: boolean } = {
    'DELIVERY': false,
    'IN_STORE': false
  };

  constructor(private settingService: SettingsDattaService,
              private dataService: DataService,
              public toast: ToastService,
              private ngZone: NgZone,
              private mapsAPILoader: MapsAPILoader,
              public spinner: NgxSpinnerService) {

              }

  ngOnInit(): void {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
      const places = this.searchElement;
      // if (places) {
      const autocomplete = new google.maps.places.Autocomplete(places?.nativeElement ?? '');

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
    this.spinner.show();
    this.initCategories();
    this.initCountries();
    this.getDetails()
  }

  public initCategories() {
    this.dataService.getStoreCategories().subscribe((next: any) => {
        this.categoryList = next?.content;
      },
      error => {
        console.log(error);
      })
  }

  public getDetails() {
    this.spinner.show();
    this.settingService.getSettingDetails().subscribe((res: any) => {
        this.data = res;
        this.initStoreDetails();
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        console.log(error);
      })
  }


  public updateSelectedTag(val: number) {
    this.selectedTab = val;
  }

  markerDragEnd($event: any) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.data = {
      ...this.data,
      store: {
        ...this.data.store,
        location: {
          ...this.data.store.location,
          latitude: this.latitude,
          longitude: this.longitude
        }
      }
    }
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude: number, longitude: number) {
    this.loadAddress = true;
    if (this.geoCoder)
      this.geoCoder.geocode({location: {lat: latitude, lng: longitude}}, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
          } else {
            window.alert('No results found');
          }
        } else {

          if (status == 'ZERO_RESULTS') {
            this.address = 'location selected on the map';
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
        this.loadAddress = false;
      });
  }

  public initStoreDetails() {
    this.transferDetails = this.data.storeTransferDetails;
    this.accountDetails = {
      firstName: this.data.accountDetail.firstName,
      lastName: this.data.accountDetail.lastName,
      emailAddress: this.data.accountDetail.emailAddress,
      contactNumber: this.data.accountDetail.contactNumber,
    }
    this.countryId = this.data?.store?.location?.country?.id;
    this.storeDetails = {
      name: this.data.store?.name,
      category: this.data?.store?.storeCategory,
      currency: this.data?.store?.location?.country?.defaultCurrency?.code,
      description: this.data?.store?.description,
      imageURL: this.data?.store.logoUrl
    }
    this.ecommerceStoreConfig = this.data.store.ecommerceStoreConfig;
  }

  onSelectCategory(val: any) {
    this.storeDetails = {...this.storeDetails, category: {...this.storeDetails.category, id: val.target.value}}

  }

  public onSaveTransferDetails() {
    if (!this.transferDetails.countryCode || !this.transferDetails.bankName || !this.transferDetails.IBAN) {
      this.toast.error('Missing Transfer Details Field!');
      return;
    }
    
    this.data = {
      ...this.data,
      storeTransferDetails: {
        ...this.transferDetails
      },
      store: {
        ...this.data.store,
        ecommerceStoreConfig: this.ecommerceStoreConfig
      }
    } 
    this.spinner.show();
    this.SaveChanges();
  }

  public onSaveAccountDetails() {
    if (!this.accountDetails.contactNumber || !this.accountDetails.emailAddress
      || !this.accountDetails.lastName || !this.accountDetails.firstName
    ) {
      this.toast.error('Missing Field!');
      return;
    }
    this.data = {
      ...this.data,
      accountDetail: {
        ...this.data.accountDetail,
        ...this.accountDetails

      }
    }
    this.spinner.show();
    this.SaveChanges();
  }

  public onSaveLocation() {
    if (!this.data?.store?.location?.country?.id) {
      this.toast.error('Missing Field!');
      return;
    }
    const country = this.getCountryById(this.countryId)
    this.data = {
      ...this.data,
      store: {
        ...this.data.store,
        location: {
          ...this.data.store.location,
          country: {
            ...this.data.store.location.country,
            ...country
          }
        }
      }
    }
    this.spinner.show();
    this.SaveChanges();
  }

  public onSaveDetails() {
    if (!this.storeDetails.name || !this.storeDetails.description
      || !this.storeDetails.category ||
      !this.storeDetails.imageURL) {
      this.toast.error('Missing Field!');
      return;
    }
    this.spinner.show();
    this.data = {
      ...this.data,
      store: {
        ...this.data.store,
        name: this.storeDetails.name,
        storeCategory: this.storeDetails.category,
        description: this.storeDetails.description,
        logoUrl: this.storeDetails.imageURL,
        ecommerceStoreConfig: this.ecommerceStoreConfig
      }
    }
    this.SaveChanges();

  }

  public onLogoChange(event: { target: any; }) {
    const input = event.target;
    if (input.files && input.files[0]) {
      this.logoFileReader.readAsDataURL(input.files[0]);
      this.logoFileToUpload = input.files[0];
      this.spinner.show();
      this.uploadLogo(this.logoFileToUpload).then((res: any) => {
        this.storeDetails = {...this.storeDetails, imageURL: res.fileUrl};
        this.spinner.hide();

      })
    }
  }

  onLogoChangeDropped(files: FileHandle[]): void {
    if (files && files[0]) {
      this.logoFileReader.readAsDataURL(files[0].file);
      this.logoFileToUpload = files[0].file;
      this.spinner.show();
      this.uploadLogo(this.logoFileToUpload).then((res: any) => {
        this.spinner.hide();
        this.storeDetails = {...this.storeDetails, imageURL: res.fileUrl};
      })
    }
  }

  uploadLogo(file: any) {
    return this.dataService.uploadImage(file);
  }

  public initCountries() {
    this.dataService.getStoreCountries().subscribe((res: any) => {
        this.countriesList = res;
      },
      error => {
        console.log(error);
      })
  }

  public getCountryById(id: any) {
    return this.countriesList.find(x => x.id == id);
  }

  public SaveChanges() {
    this.settingService.updateSettingDetails(this.data).subscribe((res: any) => {
        this.toast.success("Saved Successfully")
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      })
  }

  public onSaveEcommerceSettings() {
    // Format all time values to include seconds
    if (this.ecommerceStoreConfig?.availabilitySchedules?.length > 0) {
      this.ecommerceStoreConfig.availabilitySchedules = this.ecommerceStoreConfig.availabilitySchedules.map(
        (schedule: AvailabilitySchedule) => ({
          ...schedule,
          startTime: this.formatTimeWithSeconds(schedule.startTime),
          endTime: this.formatTimeWithSeconds(schedule.endTime)
        })
      );
    }

    this.data = {
      ...this.data,
      store: {
        ...this.data.store,
        ecommerceStoreConfig: this.ecommerceStoreConfig
      }
    }
    this.spinner.show();
    this.SaveChanges();
  }

  // Format time to ensure it includes seconds (HH:MM:00)
  public formatTimeWithSeconds(time: string): string {
    if (!time) return '00:00:00';
    
    // If time already has seconds, return it
    if (time.split(':').length === 3) return time;
    
    // If time is in HH:MM format, add :00 for seconds
    if (time.split(':').length === 2) return `${time}:00`;
    
    // If time is in some other format, try to parse it
    try {
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
    } catch (e) {
      console.error('Invalid time format:', time);
      return '00:00:00';
    }
  }

  addAvailabilitySchedule(type: 'DELIVERY' | 'IN_STORE') {
    const availableDays = this.getAvailableDays(type, -1);
    const newSchedule: AvailabilitySchedule = {
      deliveryMethod: type,
      day: availableDays[0],
      startTime: '09:00:00',
      endTime: '17:00:00',
      isActive: true
    };

    if (!this.ecommerceStoreConfig.availabilitySchedules) {
      this.ecommerceStoreConfig.availabilitySchedules = [];
    }
    
    this.ecommerceStoreConfig.availabilitySchedules.push(newSchedule);
  }

  removeAvailabilitySchedule(index: number, type: 'DELIVERY' | 'IN_STORE') {
    const schedules = this.getSchedulesByType(type);
    const scheduleToRemove = schedules[index];
    const actualIndex = this.ecommerceStoreConfig.availabilitySchedules.findIndex(
      (schedule: AvailabilitySchedule) => schedule === scheduleToRemove
    );
    if (actualIndex !== -1) {
      this.ecommerceStoreConfig.availabilitySchedules.splice(actualIndex, 1);
    }
  }

  updateScheduleStatus(index: number) {
    this.ecommerceStoreConfig.availabilitySchedules[index].isActive = 
      !this.ecommerceStoreConfig.availabilitySchedules[index].isActive;
  }

  getSchedulesByType(type: 'DELIVERY' | 'IN_STORE'): AvailabilitySchedule[] {
    if (!this.ecommerceStoreConfig?.availabilitySchedules) {
      return [];
    }
    return this.ecommerceStoreConfig.availabilitySchedules.filter(
      (schedule: AvailabilitySchedule) => schedule.deliveryMethod === type
    );
  }

  canAddMoreDays(type: 'DELIVERY' | 'IN_STORE'): boolean {
    const schedules = this.getSchedulesByType(type);
    return schedules.length < 7;
  }

  isDayDuplicate(type: 'DELIVERY' | 'IN_STORE', day: string, currentIndex: number): boolean {
    const schedules = this.getSchedulesByType(type);
    return schedules.some((schedule, index) => schedule.day === day && index !== currentIndex);
  }

  onDayChange(type: 'DELIVERY' | 'IN_STORE', index: number, day: string) {
    if (this.isDayDuplicate(type, day, index)) {
      this.dayError[index] = 'This day is already scheduled';
      // Reset to previous value after a short delay
      setTimeout(() => {
        const schedules = this.getSchedulesByType(type);
        const availableDays = this.days.filter(d => 
          !schedules.some((s, i) => i !== index && s.day === d)
        );
        this.ecommerceStoreConfig.availabilitySchedules[index].day = availableDays[0];
        this.dayError[index] = '';
      }, 2000);
    } else {
      this.dayError[index] = '';
    }
  }

  getAvailableDays(type: 'DELIVERY' | 'IN_STORE', currentIndex: number): string[] {
    const schedules = this.getSchedulesByType(type);
    return this.days.filter(day => 
      !schedules.some((schedule, index) => index !== currentIndex && schedule.day === day)
    );
  }

  fillRemainingDays(type: 'DELIVERY' | 'IN_STORE') {
    const schedules = this.getSchedulesByType(type);
    if (schedules.length === 0) {
      this.toast.error('Add at least one day first');
      return;
    }

    const template = schedules[0];
    const availableDays = this.getAvailableDays(type, -1);

    availableDays.forEach(day => {
      const newSchedule: AvailabilitySchedule = {
        deliveryMethod: type,
        day: day,
        startTime: template.startTime,
        endTime: template.endTime,
        isActive: template.isActive
      };
      this.ecommerceStoreConfig.availabilitySchedules.push(newSchedule);
    });
  }

  toggleSection(type: 'DELIVERY' | 'IN_STORE') {
    this.minimizedSections[type] = !this.minimizedSections[type];
  }
}
